export default "__VITE_ASSET__BlwtKrjU__"